import { type ClassValue, clsx } from 'clsx'
import * as emoji from 'node-emoji'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

export function unemojify(currentMessage: string) {
	let message = currentMessage

	try {
		message = emoji.unemojify(currentMessage)
	} catch (error) {
		console.error(error)
		message = currentMessage
	}

	return message
}

export function emojify(currentMessage: string) {
	let message = currentMessage

	try {
		message = emoji.emojify(currentMessage)
	} catch (error) {
		console.error(error)
		message = currentMessage
	}

	return message
}
